import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { Directives } from '../doc/directives.js';
import { Document } from '../doc/Document.js';
import { YAMLWarning, YAMLParseError } from '../errors.js';
import { isCollection, isPair } from '../nodes/identity.js';
import { composeDoc } from './compose-doc.js';
import { resolveEnd } from './resolve-end.js';

function getErrorPos(src) {
  if (typeof src === 'number') return [src, src + 1];
  if (Array.isArray(src)) return src.length === 2 ? src : [src[0], src[1]];
  var offset = src.offset,
      source = src.source;
  return [offset, offset + (typeof source === 'string' ? source.length : 1)];
}

function parsePrelude(prelude) {
  var _prelude;

  var comment = '';
  var atComment = false;
  var afterEmptyLine = false;

  for (var i = 0; i < prelude.length; ++i) {
    var source = prelude[i];

    switch (source[0]) {
      case '#':
        comment += (comment === '' ? '' : afterEmptyLine ? '\n\n' : '\n') + (source.substring(1) || ' ');
        atComment = true;
        afterEmptyLine = false;
        break;

      case '%':
        if (((_prelude = prelude[i + 1]) === null || _prelude === void 0 ? void 0 : _prelude[0]) !== '#') i += 1;
        atComment = false;
        break;

      default:
        // This may be wrong after doc-end, but in that case it doesn't matter
        if (!atComment) afterEmptyLine = true;
        atComment = false;
    }
  }

  return {
    comment: comment,
    afterEmptyLine: afterEmptyLine
  };
}
/**
 * Compose a stream of CST nodes into a stream of YAML Documents.
 *
 * ```ts
 * import { Composer, Parser } from 'yaml'
 *
 * const src: string = ...
 * const tokens = new Parser().parse(src)
 * const docs = new Composer().compose(tokens)
 * ```
 */


var Composer = /*#__PURE__*/function () {
  function Composer() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Composer);

    this.doc = null;
    this.atDirectives = false;
    this.prelude = [];
    this.errors = [];
    this.warnings = [];

    this.onError = function (source, code, message, warning) {
      var pos = getErrorPos(source);
      if (warning) _this.warnings.push(new YAMLWarning(pos, code, message));else _this.errors.push(new YAMLParseError(pos, code, message));
    }; // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing


    this.directives = new Directives({
      version: options.version || '1.2'
    });
    this.options = options;
  }

  _createClass(Composer, [{
    key: "decorate",
    value: function decorate(doc, afterDoc) {
      var _parsePrelude = parsePrelude(this.prelude),
          comment = _parsePrelude.comment,
          afterEmptyLine = _parsePrelude.afterEmptyLine; //console.log({ dc: doc.comment, prelude, comment })


      if (comment) {
        var dc = doc.contents;

        if (afterDoc) {
          doc.comment = doc.comment ? "".concat(doc.comment, "\n").concat(comment) : comment;
        } else if (afterEmptyLine || doc.directives.docStart || !dc) {
          doc.commentBefore = comment;
        } else if (isCollection(dc) && !dc.flow && dc.items.length > 0) {
          var it = dc.items[0];
          if (isPair(it)) it = it.key;
          var cb = it.commentBefore;
          it.commentBefore = cb ? "".concat(comment, "\n").concat(cb) : comment;
        } else {
          var _cb = dc.commentBefore;
          dc.commentBefore = _cb ? "".concat(comment, "\n").concat(_cb) : comment;
        }
      }

      if (afterDoc) {
        Array.prototype.push.apply(doc.errors, this.errors);
        Array.prototype.push.apply(doc.warnings, this.warnings);
      } else {
        doc.errors = this.errors;
        doc.warnings = this.warnings;
      }

      this.prelude = [];
      this.errors = [];
      this.warnings = [];
    }
    /**
     * Current stream status information.
     *
     * Mostly useful at the end of input for an empty stream.
     */

  }, {
    key: "streamInfo",
    value: function streamInfo() {
      return {
        comment: parsePrelude(this.prelude).comment,
        directives: this.directives,
        errors: this.errors,
        warnings: this.warnings
      };
    }
    /**
     * Compose tokens into documents.
     *
     * @param forceDoc - If the stream contains no document, still emit a final document including any comments and directives that would be applied to a subsequent document.
     * @param endOffset - Should be set if `forceDoc` is also set, to set the document range end and to indicate errors correctly.
     */

  }, {
    key: "compose",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function compose(tokens) {
      var forceDoc,
          endOffset,
          _iterator,
          _step,
          token,
          _args = arguments;

      return _regeneratorRuntime.wrap(function compose$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              forceDoc = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
              endOffset = _args.length > 2 && _args[2] !== undefined ? _args[2] : -1;
              _iterator = _createForOfIteratorHelper(tokens);
              _context.prev = 3;

              _iterator.s();

            case 5:
              if ((_step = _iterator.n()).done) {
                _context.next = 10;
                break;
              }

              token = _step.value;
              return _context.delegateYield(this.next(token), "t0", 8);

            case 8:
              _context.next = 5;
              break;

            case 10:
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t1 = _context["catch"](3);

              _iterator.e(_context.t1);

            case 15:
              _context.prev = 15;

              _iterator.f();

              return _context.finish(15);

            case 18:
              return _context.delegateYield(this.end(forceDoc, endOffset), "t2", 19);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, compose, this, [[3, 12, 15, 18]]);
    })
    /** Advance the composer by one CST token. */

  }, {
    key: "next",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function next(token) {
      var _this2 = this;

      var doc, msg, error, _msg, end, dc;

      return _regeneratorRuntime.wrap(function next$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = token.type;
              _context2.next = _context2.t0 === 'directive' ? 3 : _context2.t0 === 'document' ? 7 : _context2.t0 === 'byte-order-mark' ? 16 : _context2.t0 === 'space' ? 16 : _context2.t0 === 'comment' ? 17 : _context2.t0 === 'newline' ? 17 : _context2.t0 === 'error' ? 19 : _context2.t0 === 'doc-end' ? 23 : 33;
              break;

            case 3:
              this.directives.add(token.source, function (offset, message, warning) {
                var pos = getErrorPos(token);
                pos[0] += offset;

                _this2.onError(pos, 'BAD_DIRECTIVE', message, warning);
              });
              this.prelude.push(token.source);
              this.atDirectives = true;
              return _context2.abrupt("break", 34);

            case 7:
              doc = composeDoc(this.options, this.directives, token, this.onError);
              if (this.atDirectives && !doc.directives.docStart) this.onError(token, 'MISSING_CHAR', 'Missing directives-end/doc-start indicator line');
              this.decorate(doc, false);

              if (!this.doc) {
                _context2.next = 13;
                break;
              }

              _context2.next = 13;
              return this.doc;

            case 13:
              this.doc = doc;
              this.atDirectives = false;
              return _context2.abrupt("break", 34);

            case 16:
              return _context2.abrupt("break", 34);

            case 17:
              this.prelude.push(token.source);
              return _context2.abrupt("break", 34);

            case 19:
              msg = token.source ? "".concat(token.message, ": ").concat(JSON.stringify(token.source)) : token.message;
              error = new YAMLParseError(getErrorPos(token), 'UNEXPECTED_TOKEN', msg);
              if (this.atDirectives || !this.doc) this.errors.push(error);else this.doc.errors.push(error);
              return _context2.abrupt("break", 34);

            case 23:
              if (this.doc) {
                _context2.next = 27;
                break;
              }

              _msg = 'Unexpected doc-end without preceding document';
              this.errors.push(new YAMLParseError(getErrorPos(token), 'UNEXPECTED_TOKEN', _msg));
              return _context2.abrupt("break", 34);

            case 27:
              this.doc.directives.docEnd = true;
              end = resolveEnd(token.end, token.offset + token.source.length, this.doc.options.strict, this.onError);
              this.decorate(this.doc, true);

              if (end.comment) {
                dc = this.doc.comment;
                this.doc.comment = dc ? "".concat(dc, "\n").concat(end.comment) : end.comment;
              }

              this.doc.range[2] = end.offset;
              return _context2.abrupt("break", 34);

            case 33:
              this.errors.push(new YAMLParseError(getErrorPos(token), 'UNEXPECTED_TOKEN', "Unsupported token ".concat(token.type)));

            case 34:
            case "end":
              return _context2.stop();
          }
        }
      }, next, this);
    })
    /**
     * Call at end of input to yield any remaining document.
     *
     * @param forceDoc - If the stream contains no document, still emit a final document including any comments and directives that would be applied to a subsequent document.
     * @param endOffset - Should be set if `forceDoc` is also set, to set the document range end and to indicate errors correctly.
     */

  }, {
    key: "end",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function end() {
      var forceDoc,
          endOffset,
          opts,
          doc,
          _args3 = arguments;
      return _regeneratorRuntime.wrap(function end$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              forceDoc = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : false;
              endOffset = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : -1;

              if (!this.doc) {
                _context3.next = 9;
                break;
              }

              this.decorate(this.doc, true);
              _context3.next = 6;
              return this.doc;

            case 6:
              this.doc = null;
              _context3.next = 17;
              break;

            case 9:
              if (!forceDoc) {
                _context3.next = 17;
                break;
              }

              opts = Object.assign({
                _directives: this.directives
              }, this.options);
              doc = new Document(undefined, opts);
              if (this.atDirectives) this.onError(endOffset, 'MISSING_CHAR', 'Missing directives-end indicator line');
              doc.range = [0, endOffset, endOffset];
              this.decorate(doc, false);
              _context3.next = 17;
              return doc;

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, end, this);
    })
  }]);

  return Composer;
}();

export { Composer };